import React from "react";

import WritePresenter from "./WritePresenter";

export default class extends React.Component {

  render() {
    return <WritePresenter />;
  }
}
